import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import InvoiceBatch from '../../entities/invoiceBatch';

/*
 * Delete/nullify anywhere this invoiceBatch is used in other entities
 *
 * @param {InvoiceBatch} invoiceBatch
 */
export function deleteInvoiceBatch(invoiceBatch: InvoiceBatch, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = invoiceBatch.id;
    }

    /* Remove the actual invoiceBatch */
    invoiceBatch.status = 'D';
    invoiceBatch.addedOn = newHRTimestamp();
    invoiceBatch.addedBy = getCurrentUserId();
    invoiceBatch.importSource = targetImportSource;
    invoiceBatch.importId = mergeId;
    store.dispatch(Actions.InvoiceBatchActions.removeInvoiceBatchQueue(invoiceBatch));
    
}